import React from 'react'
import './InfoPage.css'

interface InfoPageProps {
  subtitle: string
  title: string
  lead: string
  children: React.ReactNode
}

// Shared layout for the long-form pages (About, How it works, FAQ).
const InfoPage: React.FC<InfoPageProps> = ({ subtitle, title, lead, children }) => (
  <section className="info-page">
    <div className="container">
      <header className="info-page-header text-center">
        <p className="section-subtitle">{subtitle}</p>
        <h1 className="section-title">{title}</h1>
        <p className="section-description">{lead}</p>
      </header>
      <article className="info-page-body">{children}</article>
    </div>
  </section>
)

export default InfoPage
